import * as types from "./constant";
import _ from 'lodash';

let initState = {
    middlewareEnabled : false,
    inizialized : false,
};

export default function reducer(state = initState, action = "") {

  switch (action.type) {

    case types.LOAD_REDUX_STORE_FROM_LOCAL_STORAGE:

        if(action.payload.localStorageState && action.payload.localStorageState!=''){

            let newState = _.merge(_.merge(state,action.payload.localStorageState), {
                localPersistence: {
                    inizialized: true
                }
            });

            return _.cloneDeep(newState);

        }else{
            return _.merge(state, {
                localPersistence: {
                    inizialized: true
                }
            });
        }

    case types.LOAD_REDUX_STORE_FROM_LOCAL_STORAGE_CANCEL:

        return {
            ...state,
            inizialized : true
        }

    case types.ENABLE_PERSISTENCE_MIDDLEWARE:

        return {
            ...state,
            middlewareEnabled : true
        }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/storeState/persistence/reducer.js